/* globals ErrorHandler */
import { createRef } from 'react'

export default class DropzoneAttachments extends React.Component {
  constructor () {
    super()
    this.state = {
      uploaded_attachments: [],
      attachments: []
    }
    this.dropzoneRef = createRef(null)
    this.previewContainerRef = createRef(null)
  }

  UNSAFE_componentWillMount () {
    this.props.attachments && this.setState({ attachments: this.props.attachments })

    this.options = []
    if (this.props.preview_template) {
      document.querySelectorAll(`${this.props.preview_template} select#attachment_type_id option`).forEach((option) => {
        this.options.push({ value: option.value, text: option.textContent })
      })
    }
  }

  UNSAFE_componentWillReceiveProps (newProps) {
    if (!newProps.attachments) return

    const persistedAttachmentIds = newProps.attachments.map((attachment) => attachment.attachment_id)
    this.setState({
      attachments: newProps.attachments,
      uploaded_attachments: this.state.uploaded_attachments.filter(
        (attachment) => !persistedAttachmentIds.includes(attachment.attachment_id)
      )
    })
  }

  componentDidUpdate () {
    window.dispatchEvent(new Event('resize'))
  }

  async componentDidMount () {
    const { default: Dropzone } = await import('dropzone')
    if (!this.dropzoneRef.current) return

    const defaultTemplate = '<div class="dz-preview list-group-item"><img data-dz-thumbnail="true" /></div>'
    let dropzone
    // eslint-disable-next-line no-new
    new Dropzone(this.dropzoneRef.current, {
      paramName: this.props.param_name,
      url: this.props.url,
      maxFilesize: 100,
      maxFiles: this.props.maxFiles || null,
      acceptedFiles: this.props.acceptedFiles || null,
      previewsContainer: this.previewContainerRef.current,
      previewTemplate: this.props.preview_template ? document.querySelector(this.props.preview_template).innerHTML : defaultTemplate,
      ...(this.props.transformFile ? { transformFile: this.props.transformFile } : {}),
      sending: (file, xhr, formData) => {
        formData.append('authenticity_token', document.querySelector('meta[name="csrf-token"]')?.content)
        this.props.onSending?.(file, formData)
      },
      init: function () {
        dropzone = this
        this.element.classList.add('dz-inited')
        this.on('addedfile', () => {
          window.dispatchEvent(new Event('resize'))
          dropzone.element.querySelector('.panel-heading')?.classList.add('loading')
        })
        this.on('complete', () => {
          dropzone.element.querySelector('.panel-heading')?.classList.remove('loading')
        })
      },
      success: (file, data) => {
        // custom callback
        if (typeof this.props.onSuccess === 'function') this.props.onSuccess(file, data, dropzone)

        file.previewElement.classList.add('dz-success')
        const select = file.previewElement.querySelector('select')
        if (select) {
          select.disabled = false
          select.addEventListener('change', (e) => this.handleChangeType(data.id, e.target.value))
        }
        const attachment = { attachment_id: data.id, attachment_type_id: this.props.default_type }
        this.state.uploaded_attachments.push(attachment)
        this.setState({ uploaded_attachments: this.state.uploaded_attachments })

        // TODO: temporary solution for wizard
        const remover = file.previewElement.querySelector('.remover')
        if (remover) {
          remover.style.display = 'inline'
          remover.removeAttribute('data-method')
          remover.removeAttribute('data-remote')
          remover.addEventListener('click', (e) => {
            e.preventDefault()
            this.setState({ uploaded_attachments: _.reject(this.state.uploaded_attachments, (attachment) => attachment.attachment_id === data.id) })
            file.previewElement.remove()
            window.dispatchEvent(new Event('resize'))
          })
        }
      },
      error: (file, error) => {
        // custom callback
        if (typeof this.props.onError === 'function') this.props.onError(file, error, dropzone)

        file.previewElement.classList.add('dz-error')
        const errorMessage = file.previewElement.querySelector('[data-dz-errormessage]')
        if (errorMessage) errorMessage.textContent = error.error || error
        ErrorHandler.alertError(error.error || error, { delay: 5000, addOn: `${I18n.t('mailers.attachment_will_be_removed', { name: file.name })}` })
        setTimeout(() => {
          file.previewElement.remove()
          window.dispatchEvent(new Event('resize'))
        }, 5000)
      }
    })
  }

  render () {
    return (
      <div ref={this.dropzoneRef}>
        <div className='panel panel-default'>
          <div className='panel-heading p-3'>
            <div className='dz-panel dz-message'>
              <i className='ti ti-clip' />
              {I18n.t('wizard_settings.layout.drop_files')}
              {this.props.hint && <div className='hint'>{this.props.hint}</div>}
            </div>
          </div>
          {this._renderAttachments()}
          <div className='list-group attachments-previews-container text-dark' ref={this.previewContainerRef} />
          {this._renderUploadedAttachments()}

        </div>
      </div>
    )
  }

  _renderAttachments () {
    return (
      <div className='list-group attachments-previews-container text-dark'>{this.state.attachments.map((attachment, index) => {
        return (
          <div key={index} className='dz-preview list-group-item' style={{ display: attachment.destroy ? 'none' : 'block' }}>
            <div className='dz-img'>
              {attachment.attachment_format.split('/')[0] === 'image' && attachment.attachment_url && !attachment.previewFailed
                ? <img src={attachment.attachment_url} onError={() => { attachment.previewFailed = true; this.forceUpdate() }} />
                : <div className='attachment-paper-clip' />}
            </div>
            <div className='dz-details'>{attachment.attachment_name}</div>
            <div className='dz-upload-progress' />
            <div className='dz-attachment-type'>{this._renderTypeSelect(attachment, index)}</div>
            <div className='dz-status'>
              <a
                className='remover lg pull-right'
                onClick={() => { attachment.destroy = true; this.forceUpdate() }}
                style={{ display: 'block' }}
              />
            </div>
            <input type='hidden' value={attachment.attachment_id} name={`candidate[attachment_relations_attributes][${index}][attachment_id]`} />
            {attachment.id && <input type='hidden' value={attachment.id} name={`candidate[attachment_relations_attributes][${index}][id]`} />}
            {attachment.destroy && <input type='hidden' value='1' name={`candidate[attachment_relations_attributes][${index}][_destroy]`} />}
          </div>
        )
      })}
      </div>
    )
  }

  _renderUploadedAttachments () {
    return (
      <div>{this.state.uploaded_attachments.map((attachment, index) => {
        index = index + this.state.attachments.length
        return (
          <div key={index}>
            <input type='hidden' value={attachment.attachment_id} name={`candidate[attachment_relations_attributes][${index}][attachment_id]`} />
            <input type='hidden' value={attachment.attachment_type_id} name={`candidate[attachment_relations_attributes][${index}][attachment_type_id]`} />
          </div>
        )
      })}
      </div>
    )
  }

  _renderTypeSelect (attachment, index) {
    return (
      <select
        onChange={(e) => { attachment.attachment_type_id = e.target.value; this.forceUpdate() }}
        className='form-control input-sm'
        name={`candidate[attachment_relations_attributes][${index}][attachment_type_id]`}
        value={attachment.attachment_type_id}
      >{
          this.options.map((option, i) => {
            return <option key={i} value={option.value}>{option.text}</option>
          })
        }
      </select>
    )
  }

  handleChangeType (id, attachmentTypeId) {
    _.map(_.union(this.state.uploaded_attachments, this.state.attachments), (attachment) => {
      if (attachment.attachment_id === id) {
        attachment.attachment_type_id = attachmentTypeId // set attachment type
      }
      // } else if (attachment.attachment_id !== id && type === 'photo' && attachment.type === 'photo') {
      //   attachment.type = 'other'; // set "other" type to another attachments
      // }
    })
    this.forceUpdate()
  }
}

DropzoneAttachments.propTypes = {
  param_name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  default_type: PropTypes.string,
  preview_template: PropTypes.string,
  attachments: PropTypes.array,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  maxFiles: PropTypes.number,
  acceptedFiles: PropTypes.string,
  hint: PropTypes.string,
  // Passed straight through to Dropzone's own transformFile option, letting a
  // caller crop/resize a file client-side before it's uploaded (Dropzone's own
  // built-in resizeWidth/resizeHeight/resizeMethod clamp to the source size in
  // a way that silently distorts the target ratio, so callers needing an exact
  // ratio should crop with their own canvas-based transformFile instead).
  transformFile: PropTypes.func,
  // Called with (file, formData) right before upload, after the authenticity
  // token is appended - lets a caller add its own extra form fields (e.g. a
  // transformFile implementation's own computed output size).
  onSending: PropTypes.func
  // value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}
